export default {
  header: 'Niezapisane zmiany',
  message: 'Twoje zmiany zostaną utracone. Czy mimo to chcesz wyjść?',
};
